import { Component } from '@angular/core';

@Component({
  selector: 'app-inventory-website',
  templateUrl: './inventory-website.dialog.html',
  styleUrls: ['./inventory-website.dialog.scss']
})
export class InventoryWebsiteDialogComponent {

}
